"use strict";

var __values = this && this.__values || function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator,
      m = s && o[s],
      i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function next() {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Port = exports.decodePort = exports.HistoryAggregate = void 0;

var data_1 = __importDefault(require("./http/data"));

var event_1 = __importDefault(require("./event"));

var port_1 = require("./http/port");

var HistoryAggregate;

(function (HistoryAggregate) {
  HistoryAggregate[HistoryAggregate["Years"] = 0] = "Years";
  HistoryAggregate[HistoryAggregate["Months"] = 1] = "Months";
  HistoryAggregate[HistoryAggregate["Days"] = 2] = "Days";
  HistoryAggregate[HistoryAggregate["Hours"] = 3] = "Hours";
  HistoryAggregate[HistoryAggregate["Fifteens"] = 4] = "Fifteens";
  HistoryAggregate[HistoryAggregate["Decades"] = 5] = "Decades";
  HistoryAggregate[HistoryAggregate["Minutes"] = 6] = "Minutes";
  HistoryAggregate[HistoryAggregate["Seconds"] = 7] = "Seconds";
})(HistoryAggregate = exports.HistoryAggregate || (exports.HistoryAggregate = {}));

;

function aggregateToWindowSec(h) {
  if (h == HistoryAggregate.Seconds) {
    return 10;
  }

  if (h == HistoryAggregate.Minutes) {
    return 60;
  }

  if (h == HistoryAggregate.Fifteens) {
    return 900;
  }

  if (h == HistoryAggregate.Hours) {
    return 3600;
  }

  if (h == HistoryAggregate.Days) {
    return 86400;
  }

  if (h == HistoryAggregate.Months) {
    return 2592000;
  }

  if (h == HistoryAggregate.Years) {
    return 31536000;
  }

  if (h == HistoryAggregate.Decades) {
    return 31536000;
  }

  return 900;
}
/* e.g.
  { actuatable: false, entries_today: 0, entries_yesterday: 0, favorite: false,
    id: 13499, index: "/sys/pout", label: "outage", log: null, maxperiod: 2147483647,
    measuredfigures: 0, minperiod: 2147483647, reading_method: "none",
    time: "2018-01-03T16:28:23Z", type: "sys", unit: "", value: "1", value_type: "b" }
*/


function decodePort(p) {
  var valueType = p.value_type;

  if (valueType == null) {
    valueType = p.valueType;
  }

  var maxPeriod = p.maxperiod;

  if (maxPeriod == null) {
    maxPeriod = p.maxPeriod;
  }

  var minPeriod = p.minperiod;

  if (minPeriod == null) {
    minPeriod = p.minPeriod;
  }

  var readingMethod = p.reading_method;

  if (readingMethod == null) {
    readingMethod = p.readingMethod;
  }

  var measuredFigures = p.measuredfigures;

  if (measuredFigures == null) {
    measuredFigures = p.measuredFigures;
  }

  var entriesYesterday = p.entries_yesterday;

  if (entriesYesterday == null) {
    entriesYesterday = p.entriesYesterday;
  }

  var entriesToday = p.entries_today;

  if (entriesToday == null) {
    entriesToday = p.entriesToday;
  }

  var label = p.label && p.label.length > 0 ? p.label.charAt(0).toUpperCase() + p.label.slice(1) : p.label;
  return new Port(p.id, p.index, label, p.type, p.value, p.unit, new Date(p.time), valueType, maxPeriod, minPeriod, readingMethod, measuredFigures, p.actuatable, entriesYesterday, entriesToday, p.expectedToday, p.expectedYesterday, p.favorite, p.sla);
}

exports.decodePort = decodePort;

var Port =
/** @class */
function () {
  //private uuid: UUID;
  function Port(id, index, label, type, value, unit, time, valueType, maxPeriod, minPeriod, readingMethod, measuredFigures, actuatable, entriesYesterday, entriesToday, expectedToday, expectedYesterday, favorite, sla) {
    if (entriesYesterday === void 0) {
      entriesYesterday = 0;
    }

    if (entriesToday === void 0) {
      entriesToday = 0;
    }

    if (expectedToday === void 0) {
      expectedToday = 0;
    }

    if (expectedYesterday === void 0) {
      expectedYesterday = 0;
    }

    if (favorite === void 0) {
      favorite = false;
    }

    if (sla === void 0) {
      sla = undefined;
    }

    this.id = id;
    this.index = index;
    this.label = label;
    this.type = type;
    this.valueType = valueType;
    this.measuredFigures = measuredFigures;
    this.unit = unit;
    this.time = time;
    this.maxPeriod = maxPeriod;
    this.minPeriod = minPeriod;
    this.readingMethod = readingMethod;
    this.entriesToday = entriesToday;
    this.entriesYesterday = entriesYesterday;
    this.expectedToday = expectedToday;
    this.expectedYesterday = expectedYesterday;
    this.favorite = favorite;
    this.actuatable = actuatable;
    this.value = this.normalizeValue(value);
    this.history = [];
    this.sla = sla;

    if (this.expectedToday === 0 && this.expectedYesterday === 0 && this.minPeriod < 2147483647) {
      this.calculateOldSLA();
    }
  }

  Port.prototype.isCumulative = function () {
    return typeof this.valueType !== 'undefined' && this.valueType === "dc";
  };

  Port.prototype.getHistory = function (uuid, window, start, stop, cred, fixed, transform) {
    var _this = this;

    if (fixed === void 0) {
      fixed = false;
    }

    if (transform === void 0) {
      transform = "none";
    }

    var res = aggregateToWindowSec(window);

    if (res < this.minPeriod) {
      res = this.minPeriod;
    }

    return data_1.default(cred, start, stop, res, [{
      transform: {
        operation: transform,
        domain: "time"
      },
      expression: [{
        id: this.id,
        uuid: uuid
      }]
    }], fixed).then(function (ret) {
      if (ret && ret.result != null && ret.result.length > 0 && ret.result[0].entries != null && ret.result[0].entries.length > 0) {
        console.log(ret);

        _this.setHistory(ret.result[0].entries);

        return _this.history;
      }
    });
  };

  Port.prototype.setHistory = function (hist) {
    var e_1, _a;

    this.history = [];

    try {
      for (var hist_1 = __values(hist), hist_1_1 = hist_1.next(); !hist_1_1.done; hist_1_1 = hist_1.next()) {
        var h = hist_1_1.value;
        this.history.push(new event_1.default(new Date(h.age), this.normalizeValue(h.value), h.state));
      }
    } catch (e_1_1) {
      e_1 = {
        error: e_1_1
      };
    } finally {
      try {
        if (hist_1_1 && !hist_1_1.done && (_a = hist_1.return)) _a.call(hist_1);
      } finally {
        if (e_1) throw e_1.error;
      }
    }
  };

  Port.prototype.normalizeValue = function (value) {
    if (this.valueType === "i") {
      var asInt = parseInt(value);

      if (!isNaN(asInt) && isFinite(asInt)) {
        return parseInt(value);
      }
    }

    if (this.valueType === "d" || this.valueType === "dc" || this.valueType === undefined) {
      var asFloat = parseFloat(value);
      var roundTo = 3;

      if (this.measuredFigures != null) {
        roundTo = this.measuredFigures;
      }

      if (!isNaN(asFloat) && isFinite(asFloat)) {
        var multiplier = Math.pow(10, roundTo);
        return Math.round(parseFloat(asFloat.toFixed(roundTo)) * multiplier) / multiplier;
      }
    }

    return value;
  };

  Port.prototype.formattedValue = function () {
    var isNumber = this.value != null && !isNaN(Number(this.value.toString()));

    if (isNumber) {
      return this.value.toLocaleString(undefined, {
        minimumFractionDigits: this.measuredFigures,
        maximumFractionDigits: this.measuredFigures
      });
    }

    return this.value.toString();
  }; // calculate delta

  /**
   * @returns true if we have logged something on this port and we have expected to, false if not
   */


  Port.prototype.calculateOldSLA = function () {
    // Today and yesterday timepoints (in UTC)
    var utcToday = new Date();
    utcToday.setUTCHours(0, 0, 0, 0);
    var utcYesterday = new Date(utcToday.valueOf()); // because assign of date is by ref in JS

    utcYesterday.setUTCDate(utcYesterday.getUTCDate() - 1);
    this.expectedToday = 0;
    this.expectedYesterday = 0;
    this['sla'] = {
      "yesterday": 100.00,
      "today": 100.00
    };

    if (this.maxPeriod > 0 && this.maxPeriod < 86401) {
      var expectedYesterday = Math.floor(86400 / this.maxPeriod); // We keep a three hour window for the SLA expected today

      var expectedTodayMin = Math.floor(((Date.now() - utcToday.getTime()) / 1000 - 14400) / this.maxPeriod);
      var expectedTodayMax = Math.floor((Date.now() - utcToday.getTime()) / 1000 / this.maxPeriod);
      this.expectedYesterday = expectedYesterday;
      this.expectedToday = expectedTodayMin;

      if (this.entriesToday > expectedTodayMin) {
        if (this.entriesToday < expectedTodayMax) {
          this.expectedToday = this.entriesToday;
        } else {
          this.expectedToday = expectedTodayMax;
        }
      }

      var slaYesterday = this.entriesYesterday / this.expectedYesterday * 100;
      slaYesterday = slaYesterday > 100.0 ? 100.00 : slaYesterday; // cap SLA at 100%

      var slaToday = expectedTodayMin > 0 ? this.entriesToday / expectedTodayMin * 100 : 100;
      slaToday = slaToday > 100.0 ? 100 : slaToday; // cap SLA at 100%

      this['sla'] = {
        "yesterday": slaYesterday,
        "today": slaToday
      };
    } else if (this.maxPeriod === 0) {
      var yesterday = this.entriesYesterday === 0 ? 0.0 : 100.0;
      var today = this.entriesToday === 0 ? 0.0 : 100.0;
      this['sla'] = {
        "yesterday": yesterday,
        "today": today
      };
    }
  };

  Port.prototype.get = function (deviceUUID, credentials) {
    var _this = this;

    return port_1.getPort(this.index, deviceUUID, credentials).then(function (ret) {
      var p = decodePort(ret);
      _this.time = p.time;
      _this.value = p.valueType;
      _this.maxPeriod = p.maxPeriod;
      _this.minPeriod = p.minPeriod;
      _this.readingMethod = p.readingMethod;
      _this.entriesToday = p.entriesToday;
      _this.entriesYesterday = p.entriesYesterday;
      _this.expectedToday = p.expectedToday;
      _this.expectedYesterday = p.expectedYesterday;
      _this.measuredFigures = p.measuredFigures;
      return p;
    });
  };

  return Port;
}();

exports.Port = Port;
;